import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import HubForm from '../../../components/HubForm';
import HubDetails from './HubDetails';
import { listHubs, deleteHub } from '../../../api';

const seen = (hub) => hub.getLastSeenTimestamp()?.toLocaleString({ month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });

const COLUMNS = [
  { label: 'Serial number', width: '140px', minWidth: 140, render: (h) => h.getSerialNumber() },
  { label: 'Hub type', width: '110px', minWidth: 110, render: (h) => h.getHubType() },
  { label: 'Room', width: 'minmax(140px, 1fr)', minWidth: 140, render: (h) => h.getRoom()?.getIdentifier() },
  { label: 'Last seen', width: '140px', minWidth: 140, render: seen },
  { label: 'Firmware', width: '100px', minWidth: 100, render: (h) => h.getFirmwareVersion() },
  { label: 'Notes', width: 'minmax(160px, 1fr)', minWidth: 160, render: (h) => h.getNotes() }
];

export default function Hubs() {
  return (
    <ConfigTablePage
      title='Hubs'
      singular='hub'
      columns={COLUMNS}
      load={listHubs}
      idOf={(h) => h.getSerialNumber()}
      searchText={(h) => [h.getSerialNumber(), h.getRoom()?.getIdentifier(), h.getNotes()].filter(Boolean).join(' ')}
      searchPlaceholder='Search serial, room or notes'
      renderForm={(row, onSaved) => <HubForm onSuccess={onSaved} />}
      renderView={(row) => <HubDetails serialNumber={row.getSerialNumber()} />}
      viewTitle={(row) => 'Hub ' + row.getSerialNumber()}
      dialogWidth={960}
      remove={(row) => deleteHub(row.getSerialNumber())}
      deleteTitle={(row) => 'Delete hub ' + row.getSerialNumber() + '?'}
      deleteBody='The hub will no longer display or accept statuses.'
      deleted={(row) => 'Hub ' + row.getSerialNumber() + ' deleted.'}
    />
  );
}
